export default __webpack_public_path__ + "static/media/wearables.a0b776ad.png";